import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBQCGGqlc1jOO22f4UWz46q2wLa4QGIHe0",
  authDomain: "autonotify-8739d.firebaseapp.com",
  projectId: "autonotify-8739d",
  storageBucket: "autonotify-8739d.firebasestorage.app",
  messagingSenderId: "1057773926843",
  appId: "1:1057773926843:web:49748093df6ae780f56c9e"
};



// Inicializa Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
